import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../types/actionParams';

export class ResumeRunFlowTasksRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('resumeRunFlowTasks', { ids: ids });
  }
}
